const NextI18Next = require('next-i18next').default;

const verticalDetector = require('./detector');
const locales = require('../../locales');

module.exports = new NextI18Next({
  browserLanguageDetection: false,
  customDetectors: [
    verticalDetector,
  ],
  debug: false,
  detection: {
    // order: ['verticalDetector', 'querystring', 'cookie'],
    order: ['verticalDetector'],
  },
  defaultNS: 'translation',
  defaultLanguage: 'en',
  ignoreRoutes: [
    '/_next/',
    '/static/',
    '/public/',
    '/api/',
  ],
  load: 'languageOnly',
  localeExtension: 'json',
  localePath: 'src/locales/translations',
  localeStructure: '{{lng}}/{{ns}}',
  localeSubpaths: {},
  otherLanguages: [
    'es',
  ],
  resources: locales,
  serverLanguageDetection: true,
});
